import React from 'react';
import _ from 'lodash';
import viasportBackend from '../../service/viasportBackend';
import { appContext } from '../../util/decorators';
import PollForm from './PollForm.jsx';
import PollResult from './PollResult.jsx';

@appContext
export default class Poll extends React.PureComponent {
  static propTypes = {
    country: React.PropTypes.string,
    poll: React.PropTypes.shape({
      data: React.PropTypes.shape({
        question: React.PropTypes.string,
        choices: React.PropTypes.object,
        pollId: React.PropTypes.string,
      }),
    }),
  };

  constructor() {
    super();
    this.state = {
      choiceId: null,
      choices: {},
      error: false,
      hasVoted: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  checkIfVoted() {
    this.setState({
      hasVoted: localStorage.getItem(this.props.poll.data.pollId),
    });
  }

  componentDidMount() {
    this.checkIfVoted();
  }

  async handleSubmit(evt, { pollId, choiceId, country }) {
    evt.preventDefault();
    if (!choiceId) return;

    try {
      await viasportBackend.postVote(pollId, choiceId, country)
        .then(({ data: { choices } }) => this.setState({ choices }));

      this.setState({ error: false, hasVoted: true });

      try {
        localStorage.setItem(pollId, true);
      } catch (error) {
        console.log('Did not set poll as already answered in local storage', error);
      }
    } catch (error) {
      console.log('Error while saving vote', error);
      this.setState({ error: true });
    }
  }

  render() {
    const t = this.context.app.t;
    const { country, poll: { data: { question, pollId } } } = this.props;
    const choiceId = this.state.choiceId;
    const choices = { ...this.props.poll.data.choices, ...this.state.choices };
    const choicesArray = _.toArray(choices);

    return (
      <aside className="poll">
        <p>{question}</p>

        { !this.state.hasVoted &&
          <PollForm
            vote={{ pollId, choiceId, country }}
            choices={choicesArray}
            handleChoice={evt => this.setState({ choiceId: evt.target.value })}
            handleSubmit={this.handleSubmit}
            t={t}
          />
        }

        { this.state.hasVoted &&
          <PollResult choices={choicesArray}/>
        }

        {this.state.error && <p className="error">{t('Poll.error')}</p>}
      </aside>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/Poll.jsx